<div>
  <div class="extra-details-container padding-medium padding-top-none">
    <div class="grid align-center">


      <div class="cell cell-large-col-span-6 cell-large-col-start-4 cell-medium-col-span-6 cell-medium-col-start-2 cell-small-col-span-6 cell-small-col-start-0">
          <div class="extra-details" *ngIf="extras && extras.length" #extrasContainer>
            <div *ngFor="let extra of extras" class="extra-item">
              <div [ngSwitch]="extra.type">

                <div *ngSwitchCase="'banner'" class="extra-details-banner">
                  <button mat-icon-button color="primary" (click)="back()">
                    <mat-icon>west</mat-icon>
                  </button>

                  <h3 *ngIf="extra.settings?.heading">{{ extra.settings?.heading }}</h3>
                </div>

                <div *ngSwitchCase="'text_block'" class="extra-details-text-block padding-medium">
                  <h3 *ngIf="extra.settings?.heading" class="flex flex-items-center">
                    <img *ngIf="extra.settings?.['heading-image']" height="32" width="32" src="{{ apiEndpoint + '/media/' + extra.settings?.['heading-image'] }}" />
                    {{ extra.settings?.heading }}
                  </h3>
                  <div *ngIf="extra.settings?.content" [innerHTML]="extra.settings?.content" class="extra-details-text-block-markup"></div>
                  <div *ngIf="extra.settings?.button">
                    <ng-container [ngSwitch]="extra.settings?.button.link">
                      <a *ngSwitchCase="'dynamic-support-url'" mat-button color="primary" (click)="goToDynamicSupportLink()" class="extra-details-text-block-cta">{{ extra.settings?.button.label }}</a>
                      <a *ngSwitchDefault mat-button color="primary" [href]="extra.settings?.button.link" class="extra-details-text-block-cta">{{ extra.settings?.button.label }}</a>
                    </ng-container>
                  </div>
                </div>

                <div *ngSwitchCase="'accordion'" class="extra-details-accordion">
                  <h3 *ngIf="extra.settings?.heading">{{ extra.settings?.heading }}</h3>

                  <div class="extra-details-accordion-list">
                    <mat-accordion class="text-left" *ngFor="let item of extra.settings?.items">
                      <mat-expansion-panel>
                        <mat-expansion-panel-header>
                          <mat-panel-title class="padding-vertical-medium">
                            <h3>{{ item.title }}</h3>
                          </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div [innerHTML]="item.content"></div>
                      </mat-expansion-panel>
                    </mat-accordion>
                  </div>

                </div>

              </div>
            </div>
          </div>


      </div>
    </div>
  </div>
</div>









